import { Component } from '@angular/core';

@Component({
  selector: 'app-under-development-notice',
  templateUrl: './under-development-notice.component.html',
  styleUrls: ['./under-development-notice.component.scss']
})
export class UnderDevelopmentNoticeComponent {

}
